export const useAutoHide = () => {
  const header = ref<HTMLElement | null>(null)
  const getHeaderHeight = () => (header.value !== null ? header.value.offsetHeight : 0)

  return {
    header,
    ...useSmartSticky(getHeaderHeight),
  }
}
